import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { statusColors } from '@functions/status'

import useOrderItemTask from '@hooks/useOrderItemTask'
import { generateUrls } from '@hooks/useOrder'

import type { OrderItemTaskModel, StatusModel } from '@models/types'

type BuildOrderUrlParams = {
  campaignId: number,
  orderItemTaskId: number,
  status: StatusModel,
}

const buildOrderTaskUrl = (params: BuildOrderUrlParams) => {
  const { campaignId, orderItemTaskId, status } = params

  const { approvedCampaignOrdersUrl, pendingCampaignOrdersUrl } = generateUrls({ campaign_id: campaignId })

  const orderUrl = status?.key === 'approved' ? approvedCampaignOrdersUrl : pendingCampaignOrdersUrl

  const payload = encodeURIComponent(JSON.stringify({ orderItemTask: { id: orderItemTaskId } }))

  return `${orderUrl}?redirect=${generateRedirectUrl()}&showModal=CreateOrEditOrderItemTaskModal&showModalPayload=${payload}`
}

interface OrderItemTaskListItemModel {
  campaignId: number,
  canManageOrders: boolean,
  orderItemTask: Partial<OrderItemTaskModel>,
}

const OrderItemTaskListItem = (props: OrderItemTaskListItemModel) => {
  const { campaignId, canManageOrders, orderItemTask } = props

  const orderItemTaskRelations = useOrderItemTask(orderItemTask)
  const {
    orderItem: {
      title: orderItemTitle,
    },
    orderItemTask: {
      id: orderItemTaskId,
      due_date,
    },
    orderItemTaskType: {
      title: taskTypeTitle,
    },
    status,
  } = orderItemTaskRelations

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2739
      href={canManageOrders ? buildOrderTaskUrl({ campaignId, orderItemTaskId, status }) : ''}
      secondaryText={orderItemTitle}
      title={taskTypeTitle}
    >
      <Box
        alignItems="flex-end"
        flexDirection="column"
        justifyContent="center"
        marginLeft="auto"
        style={{ whiteSpace: 'nowrap' }}
        width="auto"
      >
        {/*
         // @ts-expect-error TS7053 */}
        <Text color={statusColors[status.key]}>{status?.title || 'Pending'}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {due_date ? `Due ${due_date}` : 'Not Set'}
        </Text>

      </Box>
    </DashboardModuleListItem>
  )
}

export default OrderItemTaskListItem
